import { actionCreatorFactory } from 'typescript-fsa';
import { IApiErrorParams } from '@cbridge-packages/api';
import { IPerformanceMetricsData } from './performanceMetrics.interface';

export namespace PerformanceMetricsAction {
  const actionCreator = actionCreatorFactory('PerformanceMetrics');

  export const load = actionCreator.async<void, IPerformanceMetricsData, IApiErrorParams>('LOAD');
  export const destroy = actionCreator('DESTROY');
}
